import React from 'react'

/* eslint-disable max-len */

export default props =>
  <svg {...props} xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
    <g>
      <path d="M13.5,0.5v5h5v4h-5v5.515c0,5.028,3.52,4.427,6,2.798v4.433c-6.728,3.172-12-0.064-12-4.255V9.5h-3V6.668 c0.903-0.293,2.245-0.714,2.889-1.261c0.646-0.551,1.162-1.208,1.551-1.976C9.331,2.664,9.6,1.686,9.746,0.5H13.5z" />
    </g>
  </svg>



/** WEBPACK FOOTER **
 ** /Users/kacper/workspace/react-sharingbuttons/src/icons/Tumblr.jsx
 **/